/**
 * The Prarambh mark.
 *
 * Drawn rather than imported so it inherits `currentColor` and is correct in both
 * themes without a second asset — and so it stays crisp at 20px in the header and
 * at 512px as the installed app's icon.
 *
 * The form is a rubber stamp over a document: an outer ring, a corner-clipped
 * page, and a rule through it. That is the world this data actually lives in —
 * RTO counters, endorsed certificates, stamped receipts — and it is the same
 * vernacular the colour tokens were chosen from. "Prarambh" means beginning, so
 * the mark reads as the first stamp on a file rather than a finished one.
 */
export function BrandMark({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      // Decorative here: the wordmark beside it already names the product, so
      // announcing it twice makes the link read "Prarambh Prarambh".
      aria-hidden="true"
      focusable="false"
    >
      {/* The stamp ring. Left open at the top-right so it reads as impressed ink
          rather than a plain circle. */}
      <path
        d="M27 11.2A13 13 0 1 1 20.8 5"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        fill="none"
      />

      {/* The document, corner turned. */}
      <path
        d="M11.5 9.5h6.2l3.3 3.3v9.7a1 1 0 0 1-1 1h-8.5a1 1 0 0 1-1-1V10.5a1 1 0 0 1 1-1Z"
        fill="currentColor"
        opacity="0.18"
      />
      <path
        d="M11.5 9.5h6.2l3.3 3.3v9.7a1 1 0 0 1-1 1h-8.5a1 1 0 0 1-1-1V10.5a1 1 0 0 1 1-1Z"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.6 9.6v3.3h3.3"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinejoin="round"
        fill="none"
      />

      {/* The endorsement: the line an officer actually writes on the page. */}
      <path
        d="M13.9 17.4h4.6M13.9 20.1h3"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
      />
    </svg>
  )
}
